import { createQuery } from 'react-query-kit';

import { Env } from '@/lib';

import { holidaysSchema } from './types';

export const useHolidays = createQuery<Record<string, string>, void, Error>({
  queryKey: ['holidays'],
  staleTime: Infinity,
  refetchOnMount: false,
  retry: false,
  notifyOnChangeProps: ['data'],
  fetcher: async () => {
    try {
      const r = await fetch(Env.API_HOLIDAYS);
      const json = await r.json();
      return await holidaysSchema.parseAsync(json);
    } catch (e) {
      console.error(e);
      return {};
    }
  },
});
